import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context';

/**
 * Wraps a route so only authenticated users with the given role can access it.
 * - If still loading the session, show a spinner.
 * - If not logged in, redirect to /login.
 * - If wrong role, redirect to the appropriate portal.
 */
export default function ProtectedRoute({ children, requiredRole, requiredRoles }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <span className="spinner" style={{ width: 36, height: 36 }} />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  const allowedRoles = requiredRoles || (requiredRole ? [requiredRole] : null);
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to={user.role === 'client' ? '/client-portal' : '/portal'} replace />;
  }

  return children;
}
